<template>
  <div class="bottom">
    <b-container>
      <b-row>
        <b-col>
          <h1 class="bottom-header">Contact Us</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
        <div class="divider"></div>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="bottom-col">
          <h2 class="bottom-header">BelAsia Headquarters</h2>
          <p class="bottom-para">Room 1003, <br> 10/F Boss Commercial Center, <br> 28 Ferry Street, Kowloon <br> Hong Kong 
          </p>
        </b-col>
        <b-col class="bottom-col">
          <h2 class="bottom-header">BelAsia Vietnam</h2>
          <p class="bottom-para">1st Floor,<br> 85 Nguyên Huu Cau,<br> Tan Dinh ward,<br> HCMC, VIETNAM</p>
          <p class="bottom-para">Tel : +84-8 38234598 / 38247716<br> admin@belasialabs.com </p>
        </b-col>
        <b-col class="bottom-col">
          <h2 class="bottom-header">1st Bioherm Enterprises Corp.</h2>
          <p class="bottom-para">(BelAsia Philippines)</p>
          <a href = "https://www.facebook.com/healwoundswithbioherm/" target="_blank"><img class="social-media-icons" src="../assets/img/facebook-logo.png" alt=""></a>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="divider"></div>
        </b-col>
      </b-row>
      <b-row>
        <b-col></b-col>
        <b-col></b-col>
        <b-col class="bottom-col"><p class="bottom-para">Copyright © BELASIA  - FMD  2018 </p></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line
    name: 'bottom'
}
</script>
